// eslint-disable-next-line import/no-extraneous-dependencies
import "whatwg-fetch";

export const REQUEST_REDIRECTION_PARAMS = "REQUEST_REDIRECTION_PARAMS";
export const RECEIVE_REDIRECTION_PARAMS = "RECEIVE_REDIRECTION_PARAMS";
export const RECEIVE_ERROR_REDIRECTION_PARAMS =
  "RECEIVE_ERROR_REDIRECTION_PARAMS";
export const RESET_ERROR = "RESET_ERROR";
export const RESET_REDIRECTION = "RESET_REDIRECTION";
export const RESET_REDIRECTION_PARAMS = "RESET_REDIRECTION_PARAMS";

function requestRedirection() {
  return {
    type: REQUEST_REDIRECTION_PARAMS
  };
}

function receiveRedirectParams(redirectParams) {
  return {
    type: RECEIVE_REDIRECTION_PARAMS,
    redirectParams
  };
}

function receiveRedirectError(message) {
  return {
    type: RECEIVE_ERROR_REDIRECTION_PARAMS,
    message
  };
}

export function resetError() {
  return { type: RESET_ERROR };
}

export function resetRedirection(message) {
  return {
    type: RESET_REDIRECTION,
    message
  };
}

export function resetRedirectionParams() {
  return {
    type: RESET_REDIRECTION_PARAMS
  };
}

const getCsrfToken = () => {
  const token = document.cookie.match(
    "(^|[^;]+)\\s*XSRF-TOKEN\\s*=\\s*([^;]+)"
  );
  return token ? token.pop() : "";
};

export function fetchRedirectionParams(uuid, form, type) {
  const chargeUuid = uuid;
  const requestOptions = {
    method: "POST",
    body: JSON.stringify(form),
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": getCsrfToken()
    }
  };
  return dispatch => {
    dispatch(requestRedirection());
    return window
      .fetch(`/public/v1/charge/${uuid}/submit/${type}`, requestOptions)
      .then(
        resp => {
          if (resp.status === 205) window.location.reload();
          if (resp.status === 504) {
            throw new Error("Request timeout, please try again");
          }
          return resp.json();
        },
        error => dispatch(receiveRedirectError(error))
      )
      .then(json => {
        if (json.code && json.message) throw new Error(json.message);
        if (
          (type === "card" || type === "savedcard") &&
          json.authenticationMode === "IFRAME"
        ) {
          window.threeds.authenticate({
            uuid: json.transactionUuid,
            callback: err => {
              if (err) {
                dispatch(
                  receiveRedirectError(
                    `Authentication Failed Due to a Technical Error: ${err}`
                  )
                );
              } else {
                window.location.assign(`/charge/${chargeUuid}`);
              }
            }
          });
        } else {
          dispatch(receiveRedirectParams(json));
        }
      })
      .catch(e => {
        dispatch(receiveRedirectError(e.message));
      });
  };
}
export function fetchRedirectionParamsForVpos(uuid, form, type) {
  const requestOptions = {
    method: "POST",
    body: JSON.stringify(form),
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": getCsrfToken()
    }
  };
  return dispatch => {
    dispatch(requestRedirection());
    return window
      .fetch(`/public/v1/vpos/charge/${uuid}/submit/${type}`, requestOptions)
      .then(
        resp => {
          if (resp.status === 205) window.location.reload();
          return resp.json();
        },
        error => dispatch(receiveRedirectError(error))
      )
      .then(json => {
        if (json.code && json.message) throw new Error(json.message);
        dispatch(receiveRedirectParams(json));
      })
      .catch(e => {
        dispatch(receiveRedirectError(e.message));
      });
  };
}
